import type { ResultMatches } from 'modules/payroll_bundle/components/common/helper/worksheet'
import { RESULT_CONFIG_BUTTONS } from 'modules/payroll_bundle/lib/importConfig'

type ImportConfig = {
  importId: number
  firstNameCell: string
  lastNameCell: string
  idCell: string
  netSalaryCell: string
  companyIdentifierCell: string
}

export default function buildImportConfig({
  payrollImportId,
  worksheetMatches,
}: {
  payrollImportId: number
  worksheetMatches: ResultMatches
}) {
  // Gets the `concept` cell 0-based coordinates and returns them as
  // 1-based coordinates, like "2,3"
  const getCell = (concept: string) => {
    // worksheetMatches is like { last_name: [1, 2, 'Doe'], ... }
    const match = worksheetMatches[concept]

    if (match) {
      return `${match[0] + 1},${match[1] + 1}`
    }
  }

  // => { firstNameCell: "2,3", ... }
  const cells = RESULT_CONFIG_BUTTONS.reduce(
    (acc, { id, field }) => ({ ...acc, [field]: getCell(id) }),
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    {} as Record<keyof ImportConfig, string>
  )

  const config: ImportConfig = {
    importId: payrollImportId,
    firstNameCell: cells.firstNameCell,
    lastNameCell: cells.lastNameCell,
    idCell: cells.idCell,
    netSalaryCell: cells.netSalaryCell,
    companyIdentifierCell: cells.companyIdentifierCell,
  }

  return config
}
